module.exports = __webpack_public_path__ + "static/img/arrow-down.141c1be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/arrow-down.png
// module id = P3fT
// module chunks = 0